// config/filepond-fr.js
import { setOptions } from 'filepond';

// Set French labels globally for all FilePond instances
setOptions({
  labelInvalidField: 'Champ invalide',
  labelFileWaitingForSize: 'En attente de taille',
  labelFileSizeNotAvailable: 'Taille non disponible',
  labelFileLoading: 'Chargement',
  labelFileLoadError: 'Erreur lors du chargement',
  labelFileProcessing: 'Envoi',
  labelFileProcessingComplete: 'Envoi terminé',
  labelFileProcessingAborted: 'Envoi annulé',
  labelFileProcessingError: "Erreur lors de l'envoi",
  labelFileProcessingRevertError: "Erreur lors de l'annulation",
  labelFileRemoveError: 'Erreur lors de la suppression',
  labelTapToCancel: 'Annuler',
  labelTapToRetry: 'Réessayer',
  labelTapToUndo: 'Annuler',
  labelButtonRemoveItem: 'Retirer',
  labelButtonAbortItemLoad: 'Annuler',
  labelButtonRetryItemLoad: 'Réessayer',
  labelButtonAbortItemProcessing: 'Annuler',
  labelButtonUndoItemProcessing: 'Annuler',
  labelButtonRetryItemProcessing: 'Réessayer',
  labelButtonProcessItem: 'Envoyer',
  labelFileTypeNotAllowed: 'Type de fichier non valide',
  fileValidateTypeLabelExpectedTypes: 'Attend {allButLastType} ou {lastType}'
});
